package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class EpisodeTranslationDto(
    val language: String,
    val title: String? = null,
    val description: String? = null
)
